/**
 * @generated SignedSource<<6185df2783945287867538b6f7f79665>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentHeadlineContent$data = {
  readonly headline: string | null;
  readonly socialHeadline: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"contentHeadlineTagContent">;
  readonly " $fragmentType": "contentHeadlineContent";
};
export type contentHeadlineContent$key = {
  readonly " $data"?: contentHeadlineContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentHeadlineContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentHeadlineContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "socialHeadline",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentHeadlineTagContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "5eac35e68534815bad9ca362514a9c43";

export default node;
